import { applyMiddleware, combineReducers, createStore } from "redux";
import thunk from "redux-thunk";
import coursesReducer from "./reducers/coursesReducer";
import editReducer from "./reducers/editReducer";
import formStatusReducer from "./reducers/formStatusReducer";
import headerReducer from "./reducers/headerReducer";
import questionFormStatusReducer from "./reducers/questionFormStatusReducer";
import questionReducer from "./reducers/questionReducer";
import quizzesReducer from "./reducers/quizzesReducer";
import sliderReducer from "./reducers/sliderReducer";
import topicsReducer from "./reducers/topicsReducer";
import settingsReducer from "./reducers/settingsReducer";
import announcementsReducer from "./reducers/announcementsReducer";
import statisticsReducer from "./reducers/statisticsReducer";
import leadershipBoardReducer from "./reducers/leadershipBoardReducer";
import reportsReducer from "./reducers/reportsReducer";
import liveCoursesReducer from "./reducers/liveCoursesReducer";
import accessTokenReducer from "./reducers/accessTokenReducer";
import selectCourseReducer from "./reducers/selectCourseReducer";
import searchReducer from "./reducers/searchReducer";
import courseViewReducer from "./reducers/courseViewReducer";
import advancedSearchReducer from "./reducers/advancedSearchReducer";
import commentsReducer from "./reducers/commentsReducer";
import courseLeadershipBoardReducer from "./reducers/courseLeadershipBoardReducer";
import headerNotificationReducer from "./reducers/headerNotificationReducer";
import webexTokenReducer from "./reducers/webexTokenReducer";

const rootReducer = combineReducers({
    sliderState: sliderReducer,
    coursesState: coursesReducer,
    topicsState: topicsReducer,
    headerState: headerReducer,
    formStatus: formStatusReducer,
    editState: editReducer,
    settingsState: settingsReducer,
    quizzesState: quizzesReducer,
    questionFormStatus: questionFormStatusReducer,
    questionsState: questionReducer,
    announcementsState: announcementsReducer,
    statisticsState: statisticsReducer,
    leadershipBoardState : leadershipBoardReducer,
    reportsState : reportsReducer,
    liveCoursesState : liveCoursesReducer,
    accessTokenState : accessTokenReducer,
    selectedCourseState : selectCourseReducer,
    searchState: searchReducer,
    courseViewState: courseViewReducer,
    advancedSearchState: advancedSearchReducer,
    commentsState : commentsReducer,
    courseLeadershipBoardState : courseLeadershipBoardReducer,
    headerNotificationState : headerNotificationReducer,
    webexTokenState : webexTokenReducer,
});

export const store = createStore(rootReducer, applyMiddleware(thunk))